import { RNG } from "rot-js";
import { carveShared, makeDoor } from "../carving/Carving";
import { Graph, GraphNode } from "../graph/graphUtils";
import { BasicMap } from "../BasicMap";

export const connectRooms = (rng: typeof RNG, rooms: Graph, map: BasicMap) => {
  let index: number;
  let room: GraphNode;
  for ([index, room] of rooms.entries()) {
    room.adj.forEach((idx) => {
      if (index < idx) {
        const adjRoom = rooms.get(idx);
        if (adjRoom) {
          if (rng.getUniformInt(0, 1)) {
            carveShared(map, room.bounds, adjRoom.bounds);
          } else {
            makeDoor(rng, map, room.bounds, adjRoom.bounds);
          }
        }
      }
    });
  }
};
